import React, { forwardRef, memo } from 'react'

import { DynamicStyledSystemComponent, StyledSystemProps, typographyStyles } from './atoms'

interface TypographyComponentProps {
  H1: React.ComponentType<StyledSystemProps>
  PublicH1: React.ComponentType<StyledSystemProps>
  H3: React.ComponentType<StyledSystemProps>
  H2: React.ComponentType<StyledSystemProps>
  InputText: React.ComponentType<StyledSystemProps>
  Paragraph: React.ComponentType<StyledSystemProps>
  Log: React.ComponentType<StyledSystemProps>
  SmallText: React.ComponentType<StyledSystemProps>
  Label: React.ComponentType<StyledSystemProps>
  PublicLabel: React.ComponentType<StyledSystemProps>
  InputSmallText: React.ComponentType<StyledSystemProps>
  ErrorText: React.ComponentType<StyledSystemProps>
  NotificationText: React.ComponentType<StyledSystemProps>
  ButtonText: React.ComponentType<StyledSystemProps>
  ButtonSmallText: React.ComponentType<StyledSystemProps>
  Legend: React.ComponentType<StyledSystemProps>
  TabText: React.ComponentType<StyledSystemProps>
}

const createComponent = (textStyle: StyledSystemProps, displayName: string): React.ComponentType<StyledSystemProps> => {
  const Component = memo(
    forwardRef<unknown, StyledSystemProps>((props, ref) => (
      <DynamicStyledSystemComponent {...textStyle} {...props} ref={ref}>
        {props.children}
      </DynamicStyledSystemComponent>
    )),
  )
  Component.displayName = displayName

  return Component
}

export const Typography: TypographyComponentProps = {
  H1: createComponent(typographyStyles.H1, 'H1'),
  PublicH1: createComponent(typographyStyles.publicH1, 'PublicH1'),
  H3: createComponent(typographyStyles.H3, 'H3'),
  H2: createComponent(typographyStyles.H2, 'H2'),
  InputText: createComponent(typographyStyles.InputText, 'InputText'),
  Paragraph: createComponent(typographyStyles.Paragraph, 'Paragraph'),
  Log: createComponent(typographyStyles.Log, 'Log'),
  SmallText: createComponent(typographyStyles.SmallText, 'SmallText'),
  Label: createComponent(typographyStyles.Label, 'Label'),
  PublicLabel: createComponent(typographyStyles.PublicLabel, 'PublicLabel'),
  InputSmallText: createComponent(typographyStyles.InputSmallText, 'InputSmallText'),
  ErrorText: createComponent(typographyStyles.ErrorText, 'ErrorText'),
  NotificationText: createComponent(typographyStyles.NotificationText, 'NotificationText'),
  ButtonText: createComponent(typographyStyles.ButtonText, 'ButtonText'),
  ButtonSmallText: createComponent(typographyStyles.ButtonSmallText, 'ButtonSmallText'),
  Legend: createComponent(typographyStyles.Legend, 'Legend'),
  TabText: createComponent(typographyStyles.TabText, 'TabText'),
}
